module.exports = __webpack_public_path__ + "img/lt_set_up.6b279e75.png";